var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isModalVisible)?_c('Modal',{on:{"close":_vm.close}},[_c('LoginAndSignupForm',{attrs:{"hide-signup":_vm.hideSignup}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }